// extracted by mini-css-extract-plugin
export default {"verticalGap":"app-assets-javascripts-screens-LoginScreen__verticalGap--V73X6"};